/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import Accesspage from './../../common/404';
import Counsellor_Start from './../../modules/Counselling/Start';
import Counselling_List from './../../modules/Counselling/list';
import Counsellor_Profile from '../Counselling/profile';
import Finanical_Counselling from '../Counselling/Counselling-Forms/Finanical-Counselling';
import View_Finanical_Counselling from '../Counselling/Counselling-Forms/Finanical-Counselling/view';
import Counsellor_Token from './../../modules/Counselling/Token';
import Insurance_Counselling from '../Counselling/Counselling-Forms/Insurance-Counselling';
import View_Insurance_Counselling from '../Counselling/Counselling-Forms/Insurance-Counselling/view';
import Fc_Patient_copy from '../Counselling/Counselling-Forms/FC-Patient-Copy';
import Manager_Dashboard from '../Dashboard';
import Report_Finanical_Counselling from '../Manager/Report';
import Add_User from '../Manager/User/Add-User';
import Add_Role from '../Manager/Role/Add-Role';
import Role_List from '../Manager/Role/Role-List';
import Idle_TAT_Report from '../Reports/Idle-TAT-Report';
import TAT_Report from '../Reports/Tat-Report';
import User_List from '../Manager/User/User-List';
import Privilege_Create from '../Manager/Privilege/Privilege-Create';
import User_Doctor_Map from '../Manager/User/User-to-Doctor-Map';
import User_Details from '../Manager/User/User-Details';
import New_counselling_forms from '../Counselling/newCounsellingForms/index'
import Other_Counselling from './Counselling-Forms/other-service/view';
import View_document from './newCounsellingForms/viewDocument';
import Patients_List from './Patient/patients-list';
import Patient_history from './Patient/patient-history';
class Counselling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {
        // console.log(this.props);
    }
    renderbodyLayer() {
        const { slug } = this.props.match.params
        const { menuList } = this.props;
        console.log('data');
        console.log(this.props);
        let obj = null;
        menuList.map(data => {
            var subData = data
                .submenu
                .find(o => o.route === slug);
            console.log(subData);
            if (subData != undefined) {
                obj = subData;
            }
        })
        let user_data = JSON.parse(localStorage.getItem('user_data'));
        const roleid = user_data.roleid;
        if (roleid === 'RL_d4vg' || roleid === 'RL_UYUR' ||  roleid === 'RL_0rDv') {
            obj = {
                icon: "counselling.png",
                id: 22,
                menu_order: "4",
                permissions: {
                    add: "true",
                    delete: "true",
                    download: "true",
                    edit: "true",
                    view: "true",
                },
                route: "counselling",
                submenu: {
                    icon: "settings.png",
                    id: 27,
                    menu_order: "",
                    permissions: {
                        add: "false",
                        delete: "false",
                        download: "false",
                        edit: "false",
                        view: "true",
                    },
                    route: "counselling",
                    text: "counselling",
                },
                text: "counselling"
            }
        }
        var page = null;
        console.log("Queue Screen");
        console.log(obj, slug);
        if (obj !== undefined) {
            switch (slug) {
                case 'start':
                    page = <Counsellor_Start {...this.props} menuList={menuList} />;
                    break;
                case 'counselling-list':
                    page = <Counselling_List {...this.props} menuList={menuList} />;
                    break;
                case 'patients':
                    page = <Patients_List {...this.props} menuList={menuList} />;
                    break;
                case 'patient-history':
                    page = <Patient_history {...this.props} menuList={menuList} />;
                    break;
                case 'finanical-counselling':
                case 'view-finanical-counselling':
                case 'basic-details':
                    page = <New_counselling_forms {...this.props} menuList={menuList} />;
                    // page = <Finanical_Counselling {...this.props} menuList={menuList} />;
                    break;
                // case 'view-finanical-counselling':
                //     page = <View_Finanical_Counselling {...this.props} menuList={menuList} />;
                //     break;
                case 'view-document':
                    page = <View_document {...this.props} menuList={menuList} />;
                    break;

                case 'counsellor-view':
                    page = <Counsellor_Token {...this.props} menuList={menuList} />;
                    break;
                case 'insurance-counselling':
                    page = <Insurance_Counselling {...this.props} menuList={menuList} />;
                    break;
                    case 'view-insurance-counselling':
                        page = <View_Insurance_Counselling {...this.props} menuList={menuList} />;
                        break;
                    
                case 'counselling-print':
                    page = <Fc_Patient_copy {...this.props} menuList={menuList} />;
                    break;

                case 'view-other-counselling':
                    page = <Other_Counselling {...this.props} menuList={menuList} />;
                    break;
                default:
                    let submenu = null;
                    if (menuList[0]['submenu'].length !== 0) {
                        submenu = menuList[0]['submenu'][0]['route']
                    }
                    if (submenu !== null) {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}/${submenu}`);
                    } else {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}}`);
                    }
                    //page = <div></div>;
                    // page = <Generate_Token {...this.props} menuList={menuList}/>
                    // page = <Counsellor_Start {...this.props} menuList={menuList}/>                   
                    // page = <Counsellor_Token {...this.props} menuList={menuList}/>
                    // page = <Finanical_Counselling {...this.props} menuList={menuList}/>
                    // page = <Insurance_Counselling {...this.props} menuList={menuList}/>
                    // page = <Track_Bills {...this.props} menuList={menuList}/>
                    //page = <Bill_details {...this.props} menuList={menuList}/>
                    // page = <Counsellor_Profile {...this.props} menuList={menuList}/>
                    // page = <Manager_Dashboard {...this.props} menuList={menuList}/>
                    // page = <Report_Finanical_Counselling {...this.props} menuList={menuList}/>                  
                    // page = <Bill_Header_Wise {...this.props} menuList={menuList}/>
                    // page = <Add_User {...this.props} menuList={menuList}/>
                    // page = <Add_Role {...this.props} menuList={menuList}/>
                    // page = <Role_List {...this.props} menuList={menuList}/>
                    // page = <Idle_TAT_Report {...this.props} menuList={menuList}/>
                    // page = <TAT_Report {...this.props} menuList={menuList}/>
                    // page = <User_List {...this.props} menuList={menuList}/>
                    // page = <Privilege_Create {...this.props} menuList={menuList}/>
                    // page = <User_Doctor_Map {...this.props} menuList={menuList}/>
                    // page = <User_Details {...this.props} menuList={menuList}/>
                    break;
            }
        } else {
            page = <Accesspage></Accesspage>;
        }

        return page;
    }
    render() {

        return (
            <div>
                {this.renderbodyLayer()}
            </div>
        );
    }
}

export default Counselling;
